document.addEventListener('DOMContentLoaded', function() {
  const phoneLink = document.querySelector('.partners-page__phone-link');

  if (phoneLink) {
    phoneLink.addEventListener('click', function(e) {
      if (window.innerWidth > 768) {
        e.preventDefault();
        showCallbackForm();
      }
    });
  }
});